module.exports = __webpack_public_path__ + "img/52.3fdf5a0d.jpg";